import { createServerOnlyFn } from "@tanstack/react-start";

import { markOwnedContactHandoffOpened } from "@/features/provider-outreach/index.server";
import { resolveViewerProfileIdentity } from "@/lib/core/auth";
import { providerOutreachHandoffResponse } from "./handoff-response";

const handleProviderOutreachHandoffOpened = createServerOnlyFn(
    async ({
        params,
        request,
    }: {
        params: { sessionId: string };
        request: Request;
    }) => {
        const auth = await resolveViewerProfileIdentity();
        if (!auth) {
            return Response.json(
                { error: "Contact session not found." },
                { status: 404 },
            );
        }
        const result = await markOwnedContactHandoffOpened({
            request,
            sessionId: params.sessionId,
            userId: auth.appUserId,
        });
        const response = providerOutreachHandoffResponse(result);
        return Response.json(response.body, {
            status: response.status,
        });
    },
);

export const providerOutreachHandoffOpenedRoute = {
    server: {
        handlers: {
            POST: ({
                params,
                request,
            }: {
                params: { sessionId: string };
                request: Request;
            }) => handleProviderOutreachHandoffOpened({ params, request }),
        },
    },
};
